interface HeaderIconButtonProps {
  /** Material Symbols icon name */
  icon: string;
  /** Click handler */
  onClick?: () => void;
  /** Button style variant */
  variant?: "ghost" | "subtle";
  /** Additional classes */
  className?: string;
  /** Accessibility label */
  ariaLabel?: string;
}

export function HeaderIconButton({
  icon,
  onClick,
  variant = "ghost",
  className = "",
  ariaLabel,
}: HeaderIconButtonProps) {
  const baseStyles =
    "flex h-10 w-10 items-center justify-center rounded-full transition-colors cursor-pointer";

  const variantStyles = {
    ghost:
      "bg-transparent hover:bg-gray-100 dark:hover:bg-white/10 text-gray-800 dark:text-white",
    subtle:
      "bg-black/5 dark:bg-white/5 border border-black/10 dark:border-white/10 text-gray-800 dark:text-white hover:bg-black/10 dark:hover:bg-white/10",
  };

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
      aria-label={ariaLabel}
    >
      <span className="material-symbols-outlined text-2xl">{icon}</span>
    </button>
  );
}
